// Override Settings
var boostPFSFilterConfig = {
    general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		enable3rdCurrencySupport: true,
	},
	selector: {
		products: '#product-loop'
	}
};

var boostPFSTemplate = {
	'saleLabelHtml': '<div class="sale-item icn">' + boostPFSConfig.label.sale + '</div>',
	'soldOutLabelHtml': '<div class="so icn">' + boostPFSConfig.label.sold_out + '</div>',
	'newLabelHtml': '<div class="new icn">' + boostPFSConfig.label.new + '</div>',
	'vendorHtml': '<p>{{itemVendorLabel}}</p>',

	// Grid Template
	'productGridItemHtml':  '<div id="product-listing-{{itemId}}" class="product-index {{itemGridWidthClass}}" data-alpha="{{itemTitle}}" data-price="{{itemPriceAttr}}">' +
								'<div class="prod-container">' +
									'{{itemLabels}}' +
									'<div class="prod-image">' +
										'<a href="{{itemUrl}}" title="{{itemTitle}}">' +
										'<div class="reveal">' +
											'{{itemImages}}' +
										'</div>' +
									'</div>' +
								'</div>' +
								'<div class="product-info">' +
									'<a href="{{itemUrl}}"> ' +
										'{{itemVendor}}' +
										'<h3>{{itemTitle}}</h3>' +
									'</a>' +
									'<div class="price">{{itemPrice}}</div>' +
								'</div>' +
								'{{itemSwatch}}' +
								'{{itemQuickview}}' +
							'</div>',

	// Pagination Template
	'previousHtml': '<a href="{{itemUrl}}"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
	'nextHtml': '<a href="{{itemUrl}}"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
	'pageItemHtml': '<a href="{{itemUrl}}">{{itemTitle}}</a>',
	'pageItemSelectedHtml': '<span class="current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '{{itemTitle}}',
	'paginateHtml': '<span class="count"></span>{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<p>' + boostPFSConfig.label.sorting + '</p><select class="styled-select">{{sortingItems}}</select>'
};

(function () { // Add this
	BoostPFS.inject(this); // Add this

	/* some code */
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if(!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') {
				firstVariant = paramVariant[0];
			}
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add itemGridWidthClass
		var itemGridWidthClass = '';
		switch (boostPFSConfig.custom.products_per_row) {
			case 2: itemGridWidthClass = 'desktop-6 tablet-3 mobile-half'; break;
			case 3: itemGridWidthClass = 'desktop-4 tablet-2 mobile-half'; break;
			case 4: itemGridWidthClass = 'desktop-3 tablet-2 mobile-half'; break;
			default: break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add Label
		var itemLabelsHtml = '';
		if (soldOut) {
			itemLabelsHtml += boostPFSTemplate.soldOutLabelHtml;
		} else {
			var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
			itemLabelsHtml += typeof newLabel[0] != 'undefined' ? boostPFSTemplate.newLabelHtml : '';

			if (onSale) {
				itemLabelsHtml += boostPFSTemplate.saleLabelHtml;
			}
		}
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

		// Add Images
		var itemImagesHtml = '';
		if (images.length < 1) {
			itemImagesHtml = boostPFSConfig.custom.product_placeholder;
		} else {
			var imageBoxRatio = images[0]['height'] / images[0]['width'] * 100;
			var imageUrl = Utils.optimizeImage(images[0]['src'], '1x1').replace('_1x1.', '_{width}x.');
			var imageClass = boostPFSConfig.custom.secondary_images_hover == 'image_flip' && images.length > 1 ? ' first-image' : '';

			itemImagesHtml +=   '<div class="box-ratio" style="padding-bottom: ' + imageBoxRatio + '%;">' +
									'<img class="lazyload lazyload-fade' + imageClass + '" ' +
										'data-src="' + imageUrl + '" data-sizes="auto" ' +
										'data-original="' + Utils.getFeaturedImage(images, '500x') + '" ' +
										'alt="{{itemTitle}}">' +
								'</div>';
			itemImagesHtml +=   '<noscript>' +
									'<img src="' + Utils.getFeaturedImage(images, '1024x') + '" alt="{{itemTitle}}">' +
								'</noscript>';

			// Flip Image
			if (boostPFSConfig.custom.secondary_images_hover == 'image_flip' && images.length > 1) {
				var flipImageBoxRatio = images[1]['height'] / images[1]['width'] * 100;
				var flipImageUrl = Utils.optimizeImage(images[1]['src'], '1x1').replace('_1x1.', '_{width}x.');
				itemImagesHtml +=   '<div class="hidden">' +
										'<div class="box-ratio" style="padding-bottom: ' + flipImageBoxRatio + '%;">' +
											'<img class="lazyload lazyload-fade" id="' + images[1]['id'] + '" ' +
												'data-src="' + flipImageUrl + '" data-sizes="auto" ' +
												'alt="{{itemTitle}}">' +
										'</div>' +
										'<noscript>' +
											'<img src="' + Utils.optimizeImage(images[0]['src'], '1024x') + '" alt="{{itemTitle}}">' +
										'</noscript>' +
									'</div>';
			}
		}
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<div class="onsale"><span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span></div>';
			itemPriceHtml += '<div class="was"><span class="money">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span></div>';
		} else {
			itemPriceHtml += '<div class="prod-price">';
			if (priceVaries) {
				itemPriceHtml += boostPFSConfig.label.from_price + ' <span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span> - <span class="money">' + Utils.formatMoney(data.price_max, Globals.moneyFormat) + '</span>';
			} else {
				itemPriceHtml += '<span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
			}
			itemPriceHtml += '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Quick view
		var itemQuickviewHtml = '';
		if (boostPFSConfig.custom.quick_view_enable) {
			itemQuickviewHtml += '<a class="fancybox.ajax product-modal" rel="no-index nofollow" href="{{itemUrl}}?view=quick">' + boostPFSConfig.label.quick_view + '</a>';
		}
		itemHtml = itemHtml.replace(/{{itemQuickview}}/g, itemQuickviewHtml);

		// Add variant
		var itemSwatchHtml = '';
		if (boostPFSConfig.custom.alternate_colors) {
			var optionIndex = data.options_with_values.findIndex(function(e) { return (e.name).toLowerCase() == 'color' || (e.name).toLowerCase() == 'colour'; });
			var options = data.options_with_values.filter(function(e) { return (e.name).toLowerCase() == 'color' || (e.name).toLowerCase() == 'colour'; });
			if (typeof options[0] !== 'undefined') {
				itemSwatchHtml += '<div class="col-swatch">';
				itemSwatchHtml += '<ul class="' + this.slugify(options[0]['name']) + 'options " data-option-index="' + optionIndex + '">';
				for (var k = 0; k < options[0]['values'].length; k++) {
					var option = options[0]['values'][k];
					var value = option['title'];
					var imageIndex = option['image'];
					var variantImage = '';
					if (typeof data['images'][imageIndex] !== 'undefined') {
						variantImage = Utils.optimizeImage(data['images'][imageIndex]['src']);
					}
					var color = value.split(' ').length > 1 ? value.split(' ')[1] : value;
					itemSwatchHtml += '<li data-option-title="' + value + '" data-href="' + variantImage + '" class="color ' + this.slugify(value) + '">';
					if (color == 'white') {
						itemSwatchHtml += '<span style="border: 1px solid #ccc; background-color: ' + color + '; background-image: url(' + boostPFSConfig.general.asset_url.replace('boost-pfs-filter.js', this.slugify(value) + '.png') + ')"></span>';
					} else {
						itemSwatchHtml += '<span style="background-color: ' + color + '; background-image: url(' + boostPFSConfig.general.asset_url.replace('boost-pfs-filter.js', this.slugify(value) + '.png') + ')"></span>';
					}
					itemSwatchHtml += '</li>';
				}
				itemSwatchHtml += '</ul></div>';
			}
		}
		itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemPriceAttr}}/g, data.price_min);
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
      
      	var newItemUrl = Utils.buildProductItemUrl(data);
        if(buildCustomVariantItemUrl(data) !== ''){
          newItemUrl += '?variant=' + buildCustomVariantItemUrl(data);
        }
    	itemHtml = itemHtml.replace(/{{itemUrl}}/g, newItemUrl);
		//itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		} else {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage in pageArr) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';

		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}

		return html;
	};

	// Build additional attributes of product items
	ProductList.prototype.afterRender = function(data) {
		if (typeof Currency !== 'undefined' && Currency) {
			var defaultCurrency = boostPFSConfig.general.current_currency;
			Currency.convertAll( defaultCurrency, Currency.currentCurrency );
	  	}
	};

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if(!data) data = this.data;
		// Build number of products
		var from = Globals.queryParams.page == 1 ? Globals.queryParams.page : (Globals.queryParams.page - 1) * Globals.queryParams.limit + 1;
		var to = from + data.products.length - 1;
		jQ(Selector.bottomPagination).find('.count').html(boostPFSConfig.label.showing_items + ' ' + from + '-' + to + ' ' +  boostPFSConfig.label.pagination_of + ' ' + data.total_product);

		if (jQ(window).width() >= 980) {
			jQ('.product-index').hover(function(){
				jQ(this).children('.product-modal').show();
			}, function(){
				jQ(this).children('.product-modal').hide();
			})
			// Call Fancybox for product modal + stop scroll to top
			// Call Fancybox on all elemnets with class "fancybox"
			$('.product-modal').fancybox({
				padding: 0,
				margin: 0,
				transitionIn: 'fade',
				afterShow: function () {
					var context = document.querySelector(".product-quick-view");
					Events.trigger("quickview:load", context);
				},
				helpers: {
					overlay: {
						locked: false
					}
				}
			});
		}
	};
  
  	function buildCustomVariantItemUrl(data){
      var widthParam = Utils.getParam('pf_opt_width');
      var heightParam = Utils.getParam('pf_opt_size');
      var variants = data.variants;
      var variantId = '';
      for(var i = 0; i < variants.length; i++){
        var variant = variants[i];
        if(widthParam !== null && heightParam !== null){
        	if(variant.options.includes(widthParam) && variant.options.includes(heightParam)){
        		variantId = variant.id;
              	break;
        	}
        }else{
        	if(widthParam !== null && heightParam == null){
                if(variant.options.includes(widthParam)){
                    variantId = variant.id;
                    break;
                }
            }else{
                if(variant.options.includes(heightParam)){
                    variantId = variant.id;
                    break;
                }
            }
        }
      }
      return variantId;
    }
  /* Boost-228508 */
  FilterApi.beforeCall = function(eventType, eventInfo) {
    /* Change the filter params before calling api */
    Globals.queryParams.h_options = [];
    if (Globals.queryParams.pf_vl_locations) {
      const locations = ['Shanghai Factory','Chicago Location', 'Luminary NYC', 'NYC Res', 'SKW'];
      
      Globals.queryParams.h_options = locations.reduce((h_options, location) => {
        return Globals.queryParams.pf_vl_locations.includes(location)
          ? (h_options || []).concat(location)
          : h_options;
      }, []);
    } 
  }
    /* Boost-228508 */
})();